import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBars, faChartNetwork, faHouseBuilding, faUsersRectangle, faBookOpen, faEnvelope, faRulerCombined,
    faChartSimple
} from "@fortawesome/pro-light-svg-icons";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import {Link} from "react-router-dom";

const solutions = [
    {
        name: "Accueil",
        icon: faChartNetwork,
        description: "Retrouvez la liste de vos projets",
        href: '/projects',
        sameSite: true,
    },
    {
        name: 'Métrés',
        icon: faRulerCombined,
        description: 'Processez et exploitez les données de votre projet',
        href: '/takeoff/',
        sameSite: true
    },
    {
        name: 'Revues',
        icon: faHouseBuilding,
        description: "Visualisez votre projet selon les phases",
        href: import.meta.env.VITE_BOOMER_URL,
    },
    {
        name: "Activité",
        icon: faChartSimple,
        description: 'Suivez l’activité de vos équipes',
        href: `${import.meta.env.VITE_AM_URL}/ProjectFlow`
    },
    {
        name: "Administration",
        icon: faUsersRectangle,
        href: import.meta.env.VITE_AM_URL
    },
];

const callsToAction = [
    { name: 'Documentation BIM', href: import.meta.env.VITE_DOC_URL, icon: faBookOpen },
    { name: 'Contacter Treegram', href: 'mailto:contact@treegram.fr', icon: faEnvelope },
]

const ApplicationMenu: React.FC = () => (
    <Popover className="relative isolate z-11">

        <PopoverButton className="cursor-pointer py-2 px-4 hover:bg-gray-50 rounded-sm focus:outline-none shadow">
            <FontAwesomeIcon icon={faBars} className="cursor-pointer"/>
        </PopoverButton>
            
        <PopoverPanel transition 
                      className="absolute left-0 top-12 w-screen max-w-max transition data-closed:-translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in">
            <div className="overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-gray-900/5">
                <div className="grid lg:grid-cols-[repeat(5,12rem)] md:grid-cols-[repeat(4,12rem)] gap-x-4 p-6">
                    {solutions.map((item) => (
                        <div key={item.name}
                            className="group relative rounded-lg p-6 text-sm/6 hover:bg-gray-50 ">
                            <div
                                className="flex size-11 items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                <FontAwesomeIcon icon={item.icon}
                                    aria-hidden="true"
                                    className="size-6 text-gray-600 group-hover:text-indigo-600 text-xl"
                                />
                            </div>
                            {item.sameSite ? (
                                <Link to={item.href} className="mt-6 block font-semibold text-gray-900">
                                    {item.name}
                                    <span className="absolute inset-0"/>
                                </Link>
                            ) : (
                                <a href={item.href} className="mt-6 block font-semibold text-gray-900">
                                    {item.name}
                                    <span className="absolute inset-0"/>
                                </a>
                            )}
                
                            <p className="mt-1 text-gray-600">{item.description}</p>
                        </div>
                    ))}
                </div>
                <div className="bg-gray-50">
                    <div className="grid grid-cols-2 divide-x divide-gray-900/5 border-x border-gray-900/5 ">
                        {callsToAction.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-100"
                            >
                                <FontAwesomeIcon icon={item.icon} aria-hidden="true" className="size-5 flex-none"/>
                                {item.name}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </PopoverPanel>
    </Popover>
)

export default ApplicationMenu;